module.exports = __webpack_public_path__ + "img/news.fa3e1603.png";